import { amountErrorMessages, AmountValidateType, amountMaxValue, amountPattern } from "../constants";

export const validateAmount = (amount: string) => {
    if (!amount.match(amountPattern)) {
        return amountErrorMessages[AmountValidateType.onlyDigits]
    }

    const normalizedValue = parseFloat(amount.replace(',', '.'));
    return normalizedValue <= amountMaxValue || amountErrorMessages[AmountValidateType.greaterThanMaxValue]
}
